/* eslint-disable no-empty */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enUS from './src/locales/en-US.json';
import ptBr from './src/locales/pt-BR.json';

const getInitialLanguage = (): string => {
  try {
    const saved = localStorage.getItem('lang');
    if (saved) return saved;
  } catch {}
  return 'en-US';
};

i18n.use(initReactI18next).init({
  resources: {
    'en-US': { translation: enUS },
    'pt-BR': { translation: ptBr },
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en-US',
  interpolation: { escapeValue: false },
  react: { useSuspense: false },
});

export default i18n;
